import React from 'react';
import PromotionServicePage from './PromotionServicePage';

const AppleMusicPromotionPage = () => {
  return (
    <PromotionServicePage
      platform="apple_music"
      platformName="Apple Music / iTunes"
      iconColor="bg-gradient-to-br from-pink-500 to-red-500"
      description="Gagnez en visibilité sur Apple Music et iTunes avec notre promotion professionnelle."
      metaTitle="Promotion Apple Music / iTunes - 35$ | AGRP BOX"
      metaDescription="Développez votre audience sur Apple Music et iTunes : plus d'écoutes, de téléchargements et de visibilité avec AGRP BOX."
      url="/promouvoir-apple-music"
    />
  );
};

export default AppleMusicPromotionPage;
